import React from "react";
import "../styles/LeftSidebar.css"

function LeftSidebar({ isOpen, toggleSidebar }) {
  return (
    <>
      {/* Overlay to close sidebar when clicking outside */}
      {/* {isOpen && <div className="sidebar-overlay" onClick={toggleSidebar}></div>} */}
      {isOpen ? <div className="sidebar-overlay" onClick={toggleSidebar}></div> : null}

      <div className={`left-sidebar ${isOpen ? "open" : ""}`}>
        <button className="close-btn" onClick={toggleSidebar}>×</button>
        <div className="link-container">
          <h2 className="title">Korisni linkovi</h2>
          <div className="link-list">
            <ul>
              <li><a href="https://www.fer.unizg.hr/">www.fer.hr</a></li>
              <li><a href="https://www.fer.unizg.hr/studiji/prijediplomski_studij/upisi/drzavna_matura">fer/upisi-matura</a></li>
              <li><a href="https://www.fer.unizg.hr/studiji/fer3/racunarstvo">fer/racunarstvo</a></li>
              <li><a href="https://www.fer.unizg.hr/studiji/fer3/eit">fer/elektrotehnika</a></li>
            </ul>
          </div>
        </div>
      </div>
    </>
  );
}

export default LeftSidebar;